import { call, put, takeEvery, delay } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';
import * as api from '../../Utils/ajax';

// import tempbotdata from '../../../assets/BotForge_Config7.json';

import {
    GET_BOT_DATA,
    UPSERT_BOT_DATA,
    BUILD_BOT,
    DOWNLOAD_BOT_CONFIG,
    GET_BOT_LIST_DATA,
    GET_SELECTED_BOT_DATA,
    GET_LOGS,
    LOAD_CONFIG,
    GET_GENERIC_DATA,
    SAVE_GENRIC_DATA,
    DOWNLOAD_GENERIC_DATA,
    GET_BOT_INFO,
    GET_SOURCE_LIST
} from '../Actions/actions';

import {
    updateBotValue,
    updateBotListData,
    updateBotValueConfig,
    getLogsSuccess,
    getLogsError,
    loadConfigSuccess,
    loadConfigError,
    successGenericDataGet,
    successSaveGenericData,
    reloginUser,
    getBotInfoSuccess,
    getBotInfoError,
    getSourceListSuccess,
    getSourceListError
} from '../Actions/uiActions';

let fileDownload = require('js-file-download');

// const baseUrl = process.env.REACT_APP_HYB_DOMAIN ||'http://127.0.0.1:5001';
const msUrl = '/api/v1';

const fetchData = async (url) =>
    await api.get(url);

const saveData = async (url, payload) =>
    await api.put(url, payload);
    
const upsertData = async (url, payload, version) =>
    await api.post(url, payload, version);
    
const buildBot = async (url, payload) =>
    await api.post(url, payload);

export function* getSelectedBotData(params) {
    const botId = params.botId;
    const sourceName = window.localStorage.getItem('sourceName') || 'webpage';
    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    localStorage.setItem("bot_id", botId);
    let url = msUrl + '/bot-forge/config-get/' + botId + `?sourceName=${sourceName}`;
    yield delay(500);
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        const data = response.data;
        if(!params.skipConfigUpsert) yield put(updateBotValueConfig(data, botId));
        if(params.cb) {
            params.cb(data)
        }
    } catch(error) {
        if(params.errFn) {
            params.errFn(error);
        }
        console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* getBotConfigData(params) {
    const botId = window.localStorage.getItem('bot_id');
    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    const sourceName = window.localStorage.getItem('sourceName') || 'webpage';
    const url = msUrl + '/bot-forge/config-get/' + botId + `?sourceName=${sourceName}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        yield put(updateBotValue(response.data['bot-config']));
        // yield put(updateBotValue(response.data['bot-config']));
    } catch(error) {
        console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* upsertBotConfigData(params) {
    const url = msUrl + '/bot-forge/config-upsert/';

    // const url = 'http://127.0.0.1:5001/v4/bot-forge/config-upsert/';
    try {
        const response = yield call(upsertData, url, params.botData, params.version);
        if(response.status && response.status === 401) {
            yield put(reloginUser());
        }
        if(response.error) {
            throw response.error;
        }
        if(params.cb) {
            let botconfigData = response && response.data && response.data.config;
            params.cb(botconfigData);
            if (typeof botconfigData === 'object') {
                yield put(updateBotValue(botconfigData));
            }
        }
        // yield put(console.log(response));
    } catch(error) {
        if(params.err) {
            params.err(error?.message || error?.error?.message || JSON.stringify(error));
        }
        // console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* builBotByData(params) {
    const botId = {
        botId: window.localStorage.getItem('bot_id'),
        sources: params?.sources || ['webpage']
    };
    if(!botId.botId || typeof botId.botId !== "string" || botId.botId === 'null' || botId.botId === 'undefined') return;
    if(botId.botId.length <= 10) return;
    let tempUrl = params.baseUrl,url;
    const baseUrlArr = tempUrl.split('/');
    if(params.env === 'live') {
        url = msUrl + '/bot-forge/webpackbuild/';
        // url = `https://test-botforge-m.enterprisebot.co/api/v1/bot-forge/webpackbuild/` // uncomment this code for live build from localhost
    } else {
        url = tempUrl + '/v4/bot-forge/webpackbuild/';
        if(baseUrlArr[baseUrlArr.length - 1] === '') {
            url = tempUrl + 'v3/bot-forge/webpackbuild/';
        }
    }
    try {
        const response = yield call(buildBot, url, botId);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(params.cb) {
            params.cb(response, response.status);
        }
        // if((response.error && response.error.code === 400) || (response.error && response.error.message === 'You cannot build generic bots.')) {
        //     alert(response.error.message);
        // }
        
        // yield put(console.log(response));
    } catch(error) {
        if(params.err) {
            params.err(error);
        }
        console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* downloadBotConfigData(params) {
    const botId = window.localStorage.getItem('bot_id');
    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    const sourceName = window.localStorage.getItem('sourceName') || 'webpage';
    const url = msUrl + '/bot-forge/config-get/' + botId + `?sourceName=${sourceName}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        let fileText = JSON.stringify(response.data['bot-config'], null, 4);
        let fileName= `${response.data['bot-config'].botId}_${new Date().getTime()}.json`
        fileDownload(fileText, fileName);
        if(params.cb) {
            params.cb();
        }
    } catch(error) {
        if(params.err) {
            params.err();
        }
        console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* getBotListData(params) {
    const url = msUrl + '/bot-forge/bots';
    try {
        const response = yield call(fetchData, url);
        if(response && response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(params.cb)
            params.cb(response.data);

        yield put(updateBotListData(response.data));
    } catch(error) {
        if(params.err) {
            params.err(error);
        }
        console.log('error ----> ',error);
        // yield put(console.log(error));
    }
}

export function* getLogs(params) {
    const botId = params.botId ? params.botId : window.localStorage.getItem('bot_id');
    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    const sourceName = window.localStorage.getItem('sourceName') || 'webpage';
    const url = `${msUrl}/bot-forge/logs/${botId}?limit=${params.filter.limit}&skip=${params.filter.offset}&sourceName=${sourceName}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(!params.fromDash) {
            yield put(getLogsSuccess(response));
        }
        if(params.cb){
            params.cb({...response, type: "success"});
        }
    } catch(error) {
        if(!params.fromDash) {
            yield put(getLogsError(error));
        }
        if(params.cb){
            params.cb({...error, type: "error"});
        }
        // yield put(console.log(error));
    }
}

export function* getBotInfo(params) {
    // const botId = params.botId ? params.botId : window.localStorage.getItem('bot_id');
    const storageBotId = window.localStorage.getItem('bot_id');
    const botId = storageBotId ? storageBotId : params.botId || undefined;
    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    const url = `${msUrl}/bot/${botId}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            yield put(reloginUser());
            return;
        }

        yield put(getBotInfoSuccess(response?.data));
        
        if(params.cb){
            params.cb({...response?.data, type: "success"});
        }
    } catch(error) {
        yield put(getBotInfoError(error));

        if(params.cb){
            params.cb({...error, type: "error"});
        }
    }
}

export function* loadConfig(params) {
    // const botId = window.localStorage.getItem('bot_id');
    const sourceName = window.localStorage.getItem('sourceName') || 'webpage';
    const url = `${msUrl}/bot-forge/loadConfig/${params.id}?sourceName=${sourceName}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        yield put(loadConfigSuccess(response));
        if(params.cb){
            params.cb({...response, type: "success"});
        }
    } catch(error) {
        yield put(loadConfigError(error));
        if(params.cb){
            params.cb({...error, type: "error"});
        }
        // yield put(console.log(error));
    }
}

export function* getGenericData(params) {
    const lang = params.lang;
    const cb = params.cb;
    const err = params.err;
    const url = `${msUrl}/bot-forge/generic-config/${lang}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(response && response.data && response.data.UI_OPTIONS && response.data.SETTINGS) {
            if(cb){
                cb(response.data);
            }
            yield put(successGenericDataGet(response.data));
        } else {
            if(err){
                err(response);
            }
        }

        // yield put(loadConfigSuccess(response));
        
    } catch(error) {
        // yield put(loadConfigError(error));
        if(err){
            err(error);
        }
    }
}

export function* downloadGenericData(params) {
    const lang = params.lang;
    const cb = params.cb;
    const err = params.err;
    const url = `${msUrl}/bot-forge/generic-config/${lang}`;
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(response && response.data && response.data.UI_OPTIONS && response.data.SETTINGS) {
            let fileText = JSON.stringify(response.data, null, 4);
            let fileName= `${response.data.botId}_${new Date().getTime()}.json`
            fileDownload(fileText, fileName);
            if(cb){
                cb(response.data);
            }
            // yield put(successGenericDataGet(response.data));
        } else {
            if(err){
                err(response);
            }
        }

        // yield put(loadConfigSuccess(response));
        
    } catch(error) {
        // yield put(loadConfigError(error));
        if(err){
            err(error);
        }
        // yield put(console.log(error));
    }
}

export function* saveGenericData(params) {
    const lang = params.lang;
    const cb = params.cb;
    const err = params.err;
    const body = params.data;
    const url = `${msUrl}/bot-forge/generic-config/${lang}/save`;
    try {
        const response = yield call(saveData, url, body);
        if(response.status && response.status === 401) {
            //localStorage.clear();
            //window.location.href = '/';
            yield put(reloginUser());
        }
        if(response && response.data) {
            if(cb){
                cb(response.data);
            }
            yield put(successSaveGenericData(response.data));
        } else {
            if(err){
                err(response);
            }
        }

        // yield put(loadConfigSuccess(response));
        
    } catch(error) {
        // yield put(loadConfigError(error));
        if(err){
            err(error);
        }
        // yield put(console.log(error));
    }
}

export function* getSourceList(params) {
    const botId = params.botId;
    const cb = params.cb;
    const errCb = params.errCb;
    const url = `${msUrl}/bot-forge/source-list/${botId}`;

    if(!botId || typeof botId !== "string" || botId === 'null' || botId === 'undefined') return;
    if(botId.length <= 10) return;
    
    try {
        const response = yield call(fetchData, url);
        if(response.status && response.status === 401) {
            yield put(reloginUser());
        }
        if(response && response.data) {
            yield put(getSourceListSuccess(response.data));
            if(cb){
                cb(response.data);
            }
        } else {
            if(errCb){
                errCb(response);
            }
        }
    } catch(error) {
        yield put(getSourceListError(error));
        if(errCb){
            errCb(error);
        }
    }
}

export function* uiWatcher() {
    yield takeLatest(GET_BOT_DATA, getBotConfigData);
    yield takeLatest(GET_SELECTED_BOT_DATA, getSelectedBotData);
    yield takeLatest(UPSERT_BOT_DATA ,upsertBotConfigData);
    yield takeLatest(BUILD_BOT ,builBotByData);
    yield takeLatest(DOWNLOAD_BOT_CONFIG, downloadBotConfigData);
    yield takeEvery(GET_BOT_LIST_DATA, getBotListData);
    yield takeEvery(GET_LOGS, getLogs);
    yield takeLatest(LOAD_CONFIG, loadConfig);
    yield takeLatest(GET_GENERIC_DATA, getGenericData);
    yield takeLatest(SAVE_GENRIC_DATA, saveGenericData);
    yield takeLatest(DOWNLOAD_GENERIC_DATA, downloadGenericData);
    yield takeLatest(GET_BOT_INFO, getBotInfo);
    yield takeEvery(GET_SOURCE_LIST, getSourceList);
}